import { Action } from "redux";

export type IActionTypes = "T2S_LOADED";

export const actionTypes: { [key in IActionTypes]: key } = {
  T2S_LOADED: "T2S_LOADED",
};

export interface IT2SLoadedPayload {
  t2sLoaded: boolean;
}

export interface IT2SLoadedAction extends Action {
  payload: IT2SLoadedPayload;
}

export const setT2SLoaded = (payload: IT2SLoadedPayload): IT2SLoadedAction => ({
  payload,
  type: actionTypes.T2S_LOADED,
});
